<template>
    <div id="customerDiscountList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Customer Discount List</div>
                        <!-- <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
                        <div class="btn-groups pull-right">
                            <template v-if="addCardRate==true">
                                <router-link title="Add Discount"  class="btn btn-primary" v-bind:to="{name: 'CustomerDiscountCreate'}" > <i class="fp-add"> </i> Add</router-link>
                            </template>

                        </div>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-ach-detail">
                        <data-table-filter-config :moduleName="'customerDiscountList'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'customerDiscountList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listcustomerDiscountTable"
                                    mode="remote"
                                    title="Customer Discount"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='align-center'>
                                                <template>
                                                <router-link title="Update Customer Discount" class="fp-edit mr-3" v-bind:to="{name: 'CustomerDiscountEdit',params:{id:props.row.id}}"></router-link>
                                                </template>

                                            </div>
                                            <div v-else-if="props.column.field == 'name'">
                                                <template>
                                                <router-link  title="View Customer" class="color-blue"  v-bind:key="'action_view_scope' + key" v-bind:to="{name: 'DiscountCustomerList',params:{id:props.row.id}}">{{props.row.scope}}</router-link>
                                              </template >
                                              <!-- <template v-if="props.row.map_type == 'all'">
                                                {{props.row.scope}}
                                              </template> -->
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                     <div slot="selected-row-actions">
                                        <button v-if="canDeleteDiscount" id="deleteCustomerBtn" v-on:click.prevent="discountDelete" class="btn btn-danger">Delete</button>
                                    </div>

                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";


import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "CustomerDiscountList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Customer Discount List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Name',
                    field: 'name',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Type',
                    field: 'type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Percentage','Fixed'],
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Discount',
                    field: 'discount',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

            ],
            rows: [],
            totalRecords: 0,
            customer_class_value: false,
            loading:false,
            addCardRate:false,
            action:'list',
            approveRate:false,
            canDeleteDiscount:false,
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_customer_discount') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_customer_discount') {
                            self.addCardRate = true;
                        }
                        if (permissions[i].name == 'delete_customer_discount') {
                            self.canDeleteDiscount = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadCustomerClass();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listcustomerDiscountTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },
            discountDelete:function() {
                var self = this;

                self.$swal({
                      title: 'Are you sure that you want to delete this Customer Discount?',
                      type: 'info',
                      showCancelButton: true,
                      confirmButtonText: 'Yes',
                      cancelButtonText: 'No',
                      showCloseButton: false,
                      showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      self.action = 'delete';
                      self.loadList();
                    } else {
                      console.log("no");
                    }
                });
            },

            loadList() {
                var self = this;
                var data = self.$refs['listcustomerDiscountTable'].selectedRows;
                var selectedRows = [];

                for (var i = 0; i < data.length; i++) {
                    selectedRows.push(self.$refs['listcustomerDiscountTable'].selectedRows[i].id)
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action:self.action,
                    selectedRows:selectedRows,
                    selectedAll:'false'
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/customer-discount/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if (self.action == 'delete'){
                                self.action = 'list';
                                self.$swal('',data.message,'success');
                                self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'get-customer-discount-list')
                    }
                });
            },
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/CustomerDiscountList.vue